import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { TreasuryOfferBaseEntity } from '@genial/services';
import { ResponsesTreasuryMarketResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { createArrayWithBooleans } from '../../Product/components/Funds/constants';

export const messageError = '--';

export const parseDirectTreasuryContentHorizontalData = (
  item: TreasuryOfferBaseEntity,
  marketStatus: ResponsesTreasuryMarketResponse['marketStatus']
) => {
  const riskDataComponent = {
    label: 'Risco',
    value: (
      <UI.Tooltip testID="qa" label={item?.productRisk?.formatRisk || ''}>
        <HStack space={Spacing['inline.nano']} maxW={'110px'}>
          {createArrayWithBooleans(item?.productRisk?.risk || 0).map((riskRating, index) => (
            <UI.Icon
              key={index.toString()}
              testID="qa"
              name="Circle"
              size="xxxxxs"
              color={Color[riskRating ? 'neutral.darkest' : 'neutral.lightest']}
            />
          ))}
        </HStack>
      </UI.Tooltip>
    ),
  };

  const maxApplicationValue = Utils.Mask.Money(item.maximumInvestment) || messageError;
  const maturityDateFormatter = item.maturityDate
    ? Utils.Mask.DateFormat(item.maturityDate, 'dd/MM/yyyy')
    : messageError;
  const availableTime = `${marketStatus.startHour} às ${marketStatus.finishHour}`;
  const unitaryValue = Utils.Mask.Money(item.purchasePrice) || messageError;

  const parseDirectTreasuryContent = [
    {
      label: 'Valor máximo permitido',
      value: maxApplicationValue,
    },
    {
      label: 'Vencimento',
      value: maturityDateFormatter,
    },
    riskDataComponent,
    {
      label: 'Horário de disponibilidade',
      value: availableTime,
    },
    {
      label: 'Indexação',
      value: item.indexer || messageError,
    },
    {
      label: 'Preço unitário',
      value: unitaryValue,
    },
    {
      label: 'Juros',
      value: item.periodicityRate || messageError,
    },
    {
      label: 'IR',
      value: item.irInfo || messageError,
    },
    {
      label: 'IOF',
      value: item.iofInfo || messageError,
    },
  ];

  return parseDirectTreasuryContent;
};
